// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"c5af156c","662":"89f0133a"}[chunkId] + ".chunk.css";
};